//
// Glossary JS
//
let glossaryAbort = null;
let isScrollingFromClick = false;
let scrollTimeout = null;

export const initGlossary = () => {
  if (glossaryAbort) {
    glossaryAbort.abort();
  }

  const sections = document.querySelectorAll(".glossary-wrapper .glossary-content");
  const navLinks = document.querySelectorAll(".glossary-letter a");

  if (!sections.length || !navLinks.length) {
    return;
  }

  glossaryAbort = new AbortController();
  const { signal } = glossaryAbort;

  const onScroll = () => {
    const headerUnPinned = document.querySelector(".page-header.header--unpinned");

    if (!isScrollingFromClick) {
      let currentSection = null;
      let minDistance = Infinity;
      const scrollTop = window.scrollY + 90;

      sections.forEach((section) => {
        const sectionTop = section.offsetTop;
        const sectionBottom = sectionTop + section.offsetHeight;
        const id = section.getAttribute("id");

        if (scrollTop >= sectionTop && scrollTop < sectionBottom) {
          const distance = Math.abs(scrollTop - sectionTop);
          if (distance < minDistance) {
            minDistance = distance;
            currentSection = { id, section };
          }
        }
      });

      if (currentSection?.id) {
        navLinks.forEach((links) => {
          links.classList.remove("active");
        });
        const activeLink = document.querySelector(
          `.glossary-letter a[href*="${currentSection.id}"]`
        );
        activeLink?.classList.add("active");
      }
    }

    const letterWrapper = document.querySelector(".glossary-letter-wrapper");
    if (!letterWrapper) {
      return;
    }

    if (headerUnPinned) {
      letterWrapper.classList.add("sticky-section--unpinned");
      letterWrapper.classList.remove("sticky-section--pinned");
    } else {
      letterWrapper.classList.add("sticky-section--pinned");
      letterWrapper.classList.remove("sticky-section--unpinned");
    }
  };

  window.addEventListener("scroll", onScroll, { signal, passive: true });

  navLinks.forEach((link) => {
    link.addEventListener(
      "click",
      (e) => {
        e.preventDefault();
        const targetId = link.getAttribute("href")?.substring(1);
        const targetSection = targetId ? document.getElementById(targetId) : null;

        navLinks.forEach((navLink) => {
          navLink.classList.remove("active");
        });
        link.classList.add("active");

        isScrollingFromClick = true;
        if (scrollTimeout) {
          clearTimeout(scrollTimeout);
        }

        setTimeout(() => {
          const sticky = document.querySelector(".sticky-section--unpinned");
          const offset = sticky ? 95 : 200;
          if (targetSection) {
            document.documentElement.scrollTo({
              top: targetSection.offsetTop - offset,
              behavior: "smooth",
            });
          }
        }, 400);

        if (targetSection) {
          document.documentElement.scrollTo({
            top: targetSection.offsetTop - 115,
            behavior: "smooth",
          });
        }

        scrollTimeout = setTimeout(() => {
          isScrollingFromClick = false;
        }, 1200);
      },
      { signal }
    );
  });

  onScroll();
};

initGlossary();
